<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div class="vertical-menu">
    <simplebar v-if="!isCondensed" :settings="settings" class="h-100">
      <component :is="currentLeftSideMenu" />
    </simplebar>

    <simplebar v-else class="h-100">
      <component :is="currentLeftSideMenu" />
    </simplebar>
  </div>
  <!-- Left Sidebar End -->
</template>

<script>
import simplebar from 'simplebar-vue';
import CompteSideMenu from './compte/LeftSideMenu.vue';
import LeftSideMenu from './LeftSideMenu';
import AchatLeftSideMenu from './achat/LeftSideMenu';
import GpaoLeftSideMenu from './gpao/LeftSideMenu';
import ConfigurationLeftSideMenu from './configuration/LeftSideMenu';
import CrmLeftSideMenu from './crm/LeftSideMenu';
import AgendaLeftSideMenu from './agenda/LeftSideMenu';
import RhLeftSideMenu from './rh/LeftSideMenu';

export default {
  components: { simplebar, LeftSideMenu },
  props: {
    isCondensed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
    };
  },
  computed: {
    currentLeftSideMenu() {
      switch (this.$route.meta.module) {
        case 'compte':
          return CompteSideMenu;
        case 'achat':
          return AchatLeftSideMenu;
        case 'gpao':
          return GpaoLeftSideMenu;
        case 'configuration':
          return ConfigurationLeftSideMenu;
        case 'crm':
          return CrmLeftSideMenu;
        case 'agenda':
          return AgendaLeftSideMenu;
        case 'rh':
          return RhLeftSideMenu;
        default:
          return LeftSideMenu;
      }
    },
  },
  methods: {},
};
</script>
